<mat-accordion>
  <mat-expansion-panel class="mat-elevation-z0" [togglePosition]="'before'" [expanded]="false">
    <mat-expansion-panel-header class="panel-header">
      <mat-panel-title>Strictly Necessary Cookies</mat-panel-title>
      <mat-panel-description class="header-description">Always enabled</mat-panel-description>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="sg-flex-column">
        <div class="setting-description">
          <p>
            These are cookies that are required for the operation of our platform. They include, for example, cookies that enable you to log into secure areas
            of our platform, such as your account, and make use of the various services we offer. Strictly necessary cookies do not gather any information that
            could be used for marketing purposes and they do not retain information beyond the end of your visit.
          </p>
        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
  <mat-expansion-panel class="mat-elevation-z0" [togglePosition]="'before'" [expanded]="true">
    <mat-expansion-panel-header class="panel-header">
      <mat-panel-title>Analytical / Performance Cookies</mat-panel-title>
      <mat-panel-description class="header-description">
        <sg-toggle
          (click)="$event.stopPropagation()"
          [disabled]="isDisabled"
          [checked]="value.analytical"
          (checkedChange)="toggleAnalyticalCookie($event)"></sg-toggle>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="sg-flex-column">
        <div class="setting-description">
          <p>
            These are the only cookies we currently use. They allow us to recognise and count the number of visitors and to see how they interact with our
            product interface. Heat Mapping and Visitor Recording services are used to display the areas of a page where our users most frequently move the
            mouse or click. By showing us where the points of interest are, these cookies enable us to monitor and analyse traffic and user behaviour. This
            further helps us improve your experience when using our digital products and the functionality of our platform.
          </p>
          <p>
            You can learn more about the usage analytics tools and cookies we use
            <a class="sg-link" target="_blank" [routerLink]="[appName + '/cookie-policy']" [queryParams]="{ brand: 'standAlone' }">here</a>
            .
          </p>
        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
  @if (isLenderApp) {
    <mat-expansion-panel class="mat-elevation-z0" [togglePosition]="'before'" [expanded]="false">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>Mixpanel Product Analytics</mat-panel-title>
        <mat-panel-description class="header-description">
          <sg-toggle
            (click)="$event.stopPropagation()"
            [disabled]="isDisabled"
            [checked]="value.mixpanel"
            (checkedChange)="toggleMixpanelCookie($event)"></sg-toggle>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <div class="sg-flex-column">
          <div class="setting-description">
            <p>
              Mixpanel is a product-analytics and session-replay service that helps us understand how our product is used so we can improve it. Session replays
              are fully masked — no account data, figures or form inputs are recorded.
            </p>
            <p>
              You can read Mixpanel's
              <a class="sg-link" target="_blank" rel="noopener" href="https://mixpanel.com/legal/privacy-policy/">privacy policy</a>
              .
            </p>
          </div>
        </div>
      </ng-template>
    </mat-expansion-panel>
  }
</mat-accordion>
